import {
  makePaymentModalLoadingElem,
  makePaymentModalBalanceElem,
  makePaymentModalBalanceAttorneyElem,
  makePaymentModalFooterContinueElem
 } from './modal/constants'
import {
  makePaymentDashboardLoadingElem,
  accountAndBalancesContainer,
  unitsSelectContainer,
  makePaymentDashboardPaymentContainerElem,
  makePaymentDashboardBalanceElem,
  makePaymentDashboardPaymentButtonElem,
  makePaymentDashboardBalanceAttorneyElem
} from './dashboard/constants'
import { isMultipleLedgers } from './load';

export function paymentModalLoadingShow () {
  makePaymentModalLoadingElem.removeClass('hide');
  makePaymentModalBalanceElem.addClass('hide');
  makePaymentModalBalanceAttorneyElem.addClass('hide');
  makePaymentModalFooterContinueElem.addClass('hide');
}

export function paymentModalLoadingHide () {
  makePaymentModalLoadingElem.addClass('hide');
  makePaymentModalFooterContinueElem.removeClass('hide');
}

export function paymentDashboardLoadingShow () {
  makePaymentDashboardBalanceElem.addClass('hide');
  makePaymentDashboardBalanceAttorneyElem.addClass('hide');

  if (accountAndBalancesContainer) {
    accountAndBalancesContainer.addClass('hide');
    unitsSelectContainer.addClass('hide');
  }

  makePaymentDashboardLoadingElem.removeClass('hide');
}

export function paymentDashboardLoadingHide (payment = null) {
  makePaymentDashboardLoadingElem.addClass('hide')

  if (window.unitsPaymentData && window.unitsPaymentData.length > 1) {
    unitsSelectContainer.removeClass('hide');
  }

  if (accountAndBalancesContainer && payment) {
    if (isMultipleLedgers(payment)) {
      accountAndBalancesContainer.removeClass('hide');
      makePaymentDashboardPaymentButtonElem.addClass('hide');
    } else {
      makePaymentDashboardPaymentContainerElem.removeClass('hide');
      makePaymentDashboardPaymentButtonElem.removeClass('hide');
    }
  }
}
